import apiGraphQL from './apiGraphQL';

export function claimShopifySubscription({
  profileId,
  code,
}: {
  profileId: number;
  code: string;
}) {
  return new Promise<{error?: string; success: boolean}>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation ($profileId: Int!, $code: String) {
            claimShopifySubscription(profileId: $profileId, code: $code) {
              error
              success
            }
          }`,
          variables: {
            profileId,
            code,
          },
        })
        .then(response => {
          resolve(response.data.data.claimShopifySubscription);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function resendShopifySubscriptionEmail({
  shopifySubscriptionId,
}: {
  shopifySubscriptionId: number;
}) {
  return new Promise<{error?: string; success: boolean}>((resolve, reject) => {
    try {
      apiGraphQL
        .post('/graphql', {
          query: `mutation ($shopifySubscriptionId: Int!) {
            resendShopifySubscriptionEmail(shopifySubscriptionId: $shopifySubscriptionId) {
              error
              success
            }
          }`,
          variables: {
            shopifySubscriptionId,
          },
        })
        .then(response => {
          resolve(response.data.data.resendShopifySubscriptionEmail);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
